<template>
    <!--<teleport to="body">-->
    <div :class="`modal fade ${cls}`"
         :id="idReal"
         tabindex="-1"
         aria-hidden="true"
         style="display: block" :style="`z-index:${zIndex+1}`">
        <!--begin::Modal dialog-->
        <div :class="`modal-dialog modal-dialog-centered ${size}`">
            <!--begin::Modal content-->
            <div class="modal-content">
                <!--begin::Modal header-->
                <div class="modal-header" :id="`${idReal}_header`" v-if="showHeader">
                    <slot name="header">
                        <!--begin::Modal title-->
                        <h2 class="fw-bold">{{ title }}</h2>
                        <!--end::Modal title-->
                        <!--begin::Close-->
                        <div :id="`${idReal}_close`"
                             class="btn btn-icon btn-sm btn-active-icon-primary"
                             v-on:click="$emit('close')">
                            <KTIcon icon-name="cross" icon-class="fs-1" />
                        </div>
                        <!--end::Close-->
                    </slot>
                </div>
                <!--end::Modal header-->
                <!--begin::Form-->
                <!--begin::Modal body-->
                <div class="modal-body " :class="{'p-0': !showHeader, 'py-5 px-lg-10': showHeader}">
                    <slot name="body"></slot>
                </div>
                <!--end::Modal body-->
                <!--begin::Modal footer-->
                <div class="modal-footer flex-center" v-if="showFooter">
                    <slot name="footer"> </slot>
                </div>
                <!--end::Modal footer-->
                <!--end::Form-->
            </div>
        </div>
    </div>
    <div :class="`modal-backdrop fade ${cls}`"
         @click="autoClose ? $emit('close') : void(0)" :style="`z-index:${zIndex}`"></div>
    <!--</teleport>-->
</template>

<script setup>
    import { defineProps, defineEmits, ref } from "vue";
    import { onClickOutside } from "@vueuse/core";

    const props = defineProps({
        autoClose: {
            type: Boolean,
            default: true,
        },
        title: {
            type: String,
            default: "Thông tin",
        },
        size: {
            type: String,
            required: false,
            default: "mw-650px",
        },
        id: {
            type: String,
            required: false,
            default: "",
        },
        showHeader: {
            type: Boolean,
            default: true,
        },
        showFooter: {
            type: Boolean,
            default: true,
        },
    });

    const zIndex = 1050 + 10 * document.querySelectorAll(".modal").length;
    const idReal = props.id || "common_modal_" + new Date().getTime();
    const emit = defineEmits(["close"]);
    const cls = ref("");
    onMounted(() => {
        let body = document.querySelector("body");
        body.classList.add("modal-open");
        body.style.overflow = "hidden";
        setTimeout(() => {
            cls.value = "show";
        }, 100);
    });
    onUnmounted(() => {
        if (!(document.querySelector("#drawer-modal") || document.querySelector(".modal-dialog"))) {
            let body = document.querySelector("body");
            body.classList.remove("modal-open");
            body.style.overflow = "auto";
        }
    });
    const target = ref(null);
    onClickOutside(target, () => emit("close"));
</script>
